export class DepartamentoUsuario {
    id:number;
    idUser:string;
    NombreUsuario: string;
    Email: string;
    isFromDep: boolean;
}